import { LobbyTypeEnum } from '@sportspredict/shared';
import cloneDeep from 'lodash/cloneDeep';

export const MARKETS_GROUP_VISIBLE_COUNT = 20;

export const INTERVAL_30_SECONDS = 30_000;

export const REFETCH_LEADERBOARD_DELAY = 5000;

export const SCORE_OPEN_AT_UTC = Date.UTC(2025, 10, 15, 2, 0, 0);

const initFilterTabData = {
	currentSlate: null,
	isOverall: false,
	all: {
		slates: [],
		marketCategories: [],
	},
	selected: {
		slates: [],
		matches: [],
		marketCategories: [],
	},
	isDefaultState: true,
	isSingleSlateFilter: false,
};

export const MARKET_SECTIONS = {
	Active: 'active',
	MyPicks: 'my picks',
	Leaderboard: 'leaderboard',
};

export const initialSlateFiltersState = {
	tabs: {
		[MARKET_SECTIONS.MyPicks]: cloneDeep(initFilterTabData),
		[MARKET_SECTIONS.Active]: cloneDeep(initFilterTabData),
		[MARKET_SECTIONS.Leaderboard]: cloneDeep(initFilterTabData),
	},

	isInited: false,
};

export const TABS = {
	LEADERBOARD: 'leaderboard',
	HOME: 'home',
	MARKETS: 'markets',
};

export const LOBBY_TYPES = [
	{ value: LobbyTypeEnum.Classic, label: 'Classic' },
	{ value: LobbyTypeEnum.TotalWins, label: 'Select Mode' },
	{ value: LobbyTypeEnum.Survivor, label: 'Survivor' },
	{ value: LobbyTypeEnum.CrowdLock, label: 'Crowd Lock' },
	{ value: LobbyTypeEnum.HeadToHead, label: 'Head to Head' },
];

export const LOBBY_DETAILS_STORAGE_KEY = 'lobby_details';

export const HAS_SEEN_GAME_MODE_KEY = 'hasSeenGameMode';
